import Vue from "vue";
import Vuex from "vuex";
import {
	getToken,
	setToken,
	getUser,
	setUser,
	removeUserInfo,
  setLogin,
  getLogin
} from "@/utils/auth";
import getters from "./getters";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		user: evil(getUser()),
		token: getToken(),
    API_URL: "http://121.40.30.129:9021",
    isLogin: getLogin()
	},
	mutations: {
		SET_USER: (state, user) => {
			state.user = user;
		},
		SET_TOKEN: (state, token) => {
			state.token = token;
		},
		REMOVE_USERINFO: (state) => {
			state.token = null;
			state.user = null;
    },
    SET_LOGIN: (state, isLogin) => {
      state.isLogin = isLogin;
    }
	},
	actions: {
		setUser({
			commit
		}, user) {
			setUser(user);
			commit("SET_USER", user);
		},
		setToken({
			commit
		}, token) {
			setToken(token);
			commit("SET_TOKEN", token);
		},
		removeUser({
			commit
		}) {
		removeUserInfo();
			commit("REMOVE_USERINFO");
		},
		setLogin({
			commit
		}, isLogin) {
      setLogin(isLogin)
      commit("SET_LOGIN", isLogin);
		},
	},
	getters: getters,
	modules: {}
});

function evil(fn) {
	let Fn = Function
	let i = JSON.stringify(fn)
	return new Fn('return ' + i)()
}
